export const onTitle = (value: string) => {
  switch (value) {
    case 'delete':
      return 'Confirm Content Removal';
    case 'warning':
      return 'Confirm Warning Without Removal';
    case 'rejection':
      return 'Confirm Complaint Rejection';
    case 'escalation':
      return 'Confirm Escalation to a Senior Moderator';
    default:
      return '';
  }
};

export const onDescription = (value: string) => {
  switch (value) {
    case 'delete':
      return 'Are you sure you want to remove this content? This action cannot be undone.';
    case 'warning':
      return 'Are you sure you want to issue a warning without removing the content?';
    case 'rejection':
      return 'Are you sure you want to reject this complaint?';
    case 'escalation':
      return 'Are you sure you want to escalate this complaint to a senior moderator?';
    default:
      return '';
  }
};
